import { useCallback, useRef, useState } from 'react';

export const useConfirmationModal = () => {
  const [isOpen, setOpenStatus]     = useState(false);
  const promiseResolveRef = useRef<((value: boolean) => void) | null>(null);

  const openDialog = useCallback(
    () => {
      setOpenStatus(true);

      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
      });
    },
    []
  );

  const onConfirm = useCallback(() => {
    if (promiseResolveRef.current) {
      promiseResolveRef.current(true);
    }

    setOpenStatus(false);
  }, []);

  const onCancel = useCallback(() => {
    if (promiseResolveRef.current) {
      promiseResolveRef.current(false);
    }

    setOpenStatus(false);
  }, []);

  return {
    isOpen,
    openDialog,
    onConfirm,
    onCancel
  };
};
